module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.8086e19.woff2";